import {
  UpdateBriefedBudgetMutation,
  UpdateBriefedBudgetMutationVariables,
  UpdateBriefedBudget_V2Mutation,
  UpdateBriefedBudget_V2MutationVariables,
} from 'API';
import { API } from 'aws-amplify';
import { updateBriefedBudget, updateBriefedBudget_V2 } from 'graphql/mutations';

export const updateBriefBudgetNumber = async (vars: UpdateBriefedBudget_V2MutationVariables) => {
  try {
    const response = (await API.graphql({
      query: updateBriefedBudget_V2,
      variables: vars,
      authMode: 'AMAZON_COGNITO_USER_POOLS',
    })) as { data: UpdateBriefedBudget_V2Mutation };
    return response.data.updateBriefedBudget_V2?.status;
  } catch (e) {
    console.error('error', e);
  }
};
